(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else{root.BucePolish=api;api.start();}})(typeof window==='object'?window:globalThis,function(){
 'use strict';
 const amounts={2:'$15 mil',3:'$25 mil',4:'$40 mil',5:'$50 mil'};
 let labels={goal:'Con 6 pares ganas 1 gratis',missing:'Te faltan {{ count }} pares',missingOne:'Te falta 1 par',giftApplied:'Par gratis aplicado',pending:'Beneficio por confirmar',next:'Con {{ count }} pares: {{ amount }} extra',first:'Con 2 pares: $15 mil extra'};
 function copy(state){
  const n=Math.max(0,Math.floor(Number(state?.pairs)||0)),level=Math.min(6,n),confirmed=state?.confirmed===true;
  const missing=6-level;
  return {level,goal:n>=6?(confirmed?labels.giftApplied:labels.pending):labels.goal,
   current:missing===1?labels.missingOne:missing>1?labels.missing.replace('{{ count }}',String(missing)):(confirmed?state.current:labels.pending),
   next:n<2?labels.first:n<5?labels.next.replace('{{ count }}',String(n+1)).replace('{{ amount }}',amounts[n+1]):n===5?labels.missingOne:'',confirmed};
 }
 function paint(root=document){
  const state=window.BuceAH?.state();if(!state)return;
  const value=copy(state),nodes=root.matches?.('[data-buce-ah-progress]')?[root]:root.querySelectorAll('[data-buce-ah-progress]');
  nodes.forEach(node=>{
   const goal=node.querySelector('[data-ah-goal]');if(goal)goal.textContent=value.goal;
   const current=node.querySelector('[data-ah-current]');if(current)current.textContent=value.current;
   const next=node.querySelector('[data-ah-next]');if(next){next.textContent=state.confirmed?value.next:state.pairs>0?labels.pending:value.next;next.hidden=!next.textContent;}
   node.dataset.polish='true';node.style.setProperty('--buce-progress',value.level*100/6+'%');
  });
 }
 function start(){
  const script=document.querySelector('script[src*="buce-cart-polish.js"]');if(script)labels={...labels,...script.dataset};
  document.body.classList.add('buce-polish');
  document.addEventListener('buce:ah-state',()=>paint());
  const nav=document.querySelector('.t4s-toolbar');
  if(nav){
   const original=new Map([...nav.querySelectorAll('a')].map(a=>[a,a.getAttribute('aria-current')]));
   function active(){
    const opened=id=>{const el=document.getElementById(id);return el&&el.getAttribute('aria-hidden')==='false';};
    const selector=opened('t4s-search-hidden')?'.t4s-toolbart-search>a':opened('t4s-menu-drawer')?'.t4s-toolbart-nav>a':null;
    const selected=selector?nav.querySelector(selector):null;
    original.forEach((value,a)=>{const next=selected?(a===selected?'true':null):value;if(next===a.getAttribute('aria-current'))return;if(next)a.setAttribute('aria-current',next);else a.removeAttribute('aria-current');});
   }
   ['t4s-search-hidden','t4s-menu-drawer'].forEach(id=>{const el=document.getElementById(id);if(el)new MutationObserver(active).observe(el,{attributes:true,attributeFilter:['aria-hidden']});});active();
  }
 }
 return {copy,paint,start};
});
